import React from 'react';
import IntroSection from '../components/IntroSection';
import GreenSolutions from '../components/GreenSolutions';
import BlueSectionDivider from '../components/BlueSectionDivider';
import GreenBenefits from '../components/GreenBenefits';
import CountriesSection from '../components/CountriesSection';
import TechStackSection from '../components/TechStackSection';
import GreentechFaq from '../components/GreentechFaq';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const Greentech=()=>{
    return(
        <div>
            <IntroSection title="Powering Sustainable Green Technologies" paragraph="Harness the power of digital transformation for a greener future" backgroundImage="/images/greentech-bg.webp"/>
           
            <GreenSolutions/>
            <BlueSectionDivider/>
            <GreenBenefits imageSrc="https://cdn.prod.website-files.com/63d3b504212f2224c6e39423/65830ca3bdbcd77576dee450_Technical%20consultancy%20fintech.png"/>
            <BlueSectionDivider/>
            <CountriesSection/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <GreentechFaq/>
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>


        </div>
    )
}
export default Greentech;
    